import { useEffect, useState } from "react";
import api from "../lib/api";
import { Card, Overline, Icon, PageLoader, EmptyState } from "../components/ui-kit";
import { cn } from "../lib/utils";

const ICON = { test: ["FileText", "coral"], achievement: ["Trophy", "yellow"], recommendation: ["Wand2", "blue"],
  assignment: ["ClipboardList", "green"], announcement: ["Megaphone", "purple"] };

export default function NotificationsPage() {
  const [d, setD] = useState(null);
  useEffect(() => { load(); }, []);
  const load = () => api.get("/notifications").then(({ data }) => setD(data));
  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  if (!d) return <PageLoader />;

  return (
    <div className="max-w-2xl mx-auto p-4 sm:p-6">
      <div className="mb-5"><Overline>Notifications</Overline><h1 className="text-2xl font-bold text-mim-navy mt-1">Your Updates</h1></div>
      {d.items.length === 0 ? (
        <Card><EmptyState icon="BellOff" title="No notifications" subtitle="You're all caught up!" /></Card>
      ) : (
        <div className="space-y-3">
          {d.items.map((n) => {
            const [icon, tone] = ICON[n.category] || ["Bell", "blue"];
            const bg = { coral: "bg-mim-coral/10 text-mim-coral", yellow: "bg-mim-yellow/15 text-[#b07d13]", blue: "bg-mim-soft text-mim-blue", green: "bg-mim-green/10 text-mim-green", purple: "bg-mim-purple/10 text-mim-purple" }[tone];
            return (
              <Card key={n.id} onClick={() => !n.read && markRead(n.id)}
                className={cn("flex items-start gap-3 cursor-pointer", !n.read && "border-mim-blue/30 bg-mim-soft/30")}>
                <div className={cn("w-10 h-10 rounded-xl flex items-center justify-center shrink-0", bg)}><Icon name={icon} className="w-5 h-5" /></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2"><h4 className="font-semibold text-mim-navy">{n.title}</h4>{!n.read && <span className="w-2 h-2 rounded-full bg-mim-blue" />}</div>
                  <p className="text-sm text-mim-muted mt-0.5">{n.body}</p>
                  <span className="text-xs text-mim-muted mt-1 block">{new Date(n.created_at).toLocaleString()}</span>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
